// extracted by mini-css-extract-plugin
module.exports = {"menu-nav-user-links":"menu-nav-user-links_menu-nav-user-links__wyC__","menu-nav-user-links__link":"menu-nav-user-links_menu-nav-user-links__link__p42tz"};